import { Component, Input } from '@angular/core';
import { ClrDatagrid } from '@clr/angular';

@Component({
  selector: 'app-datagrid-filter-pill',
  templateUrl: './datagrid-filter-pill.component.html',
  styleUrl: './datagrid-filter-pill.component.scss'
})
export class DatagridFilterPillComponent {
  @Input() filters: any[] = [];
  @Input() dataGrid: ClrDatagrid<any>;
  @Input() filterItems: any;

  removeFilter(key: string) {
    (this.dataGrid?.columns || []).forEach(x => {
      if (x.field === key) {
        x.updateFilterValue = null;
      }
    });
  }

  removeAllFilter() {
    (this.dataGrid?.columns || []).forEach(x => {
      x.updateFilterValue = null;
    });
  }
}
